<script>
import AppHeader from '@/components/AppHeader'
import AccountModal from '@/components/AccountModal'
import AppFooter from '@/components/AppFooter'

export default {
  name: 'app',
  components: {
    AppHeader,
    AccountModal,
    AppFooter
  },
  data: function() {
    return {
      headerConfig: {
        title: 'ARM People Administration Tool',
        subtitle: 'Manage ARM People'
      }
    }
  },
  computed: {
    showCheckingLogin: function() {
      return this.$store.state.checkingLogin
    }
  },
  created: function() {
    document.title = this.headerConfig.title
  }
}
</script>

<template>
  <div id="app" class="printable">
    <FormActionPopups
      ref="formActions"
      :showSaving="showSaving"
      :showSuccess="showSuccess"
      :showDelete="showDelete"
      @saveSuccessDismissed="successDismissed"
      @deleteSuccessDismissed="successDismissed"
    />
    <b-alert
      v-model="showCheckingLogin"
      class="position-fixed fixed-top m-0 rounded-0 h-100"
      style="z-index: 2001;"
      variant="primary"
      >Checking Login...</b-alert
    >
    <AppHeader class="container" />
    <b-jumbotron id="jumbotron" class="rounded-0">
      <h1>{{ $route.meta.appTitle || headerConfig.title }}</h1>
      <h2>{{ $route.meta.appSubTitle || headerConfig.subtitle }}</h2>
    </b-jumbotron>
    <router-view id="content" class="container" />
    <AppFooter />
    <AccountModal />
  </div>
</template>

<style>
html {
  font-family: 'Proxima Nova';
  overflow-x: hidden;
  background-color: #194173;
}

#app {
  color: #414141;
  background-color: #194173;
}

#jumbotron {
  margin: 0;
  padding: 37px;
  color: white;
  text-align: center;
  background-color: #194173;
}

#jumbotron h1 {
  font-size: 2.4em;
  font-weight: bold;
  line-height: 66px;
}

#jumbotron h2 {
  font-weight: lighter;
  font-size: 1em;
  line-height: 24px;
}

.info-circle {
  font-size: 0.5em;
  vertical-align: super;
}

.under-development {
  font-style: italic;
  font-weight: bold;
  font-size: 1em;
  background-color: #bea600;
  padding: 4px;
  color: white;
  font-size: 0.6em;
}

.page {
  margin: 0 auto;
  width: 95% !important;
}

#content {
  padding: 2.5em !important;
  background-color: white;
}

.container {
  padding: 0 !important;
}

#navigation {
  background-color: #333;
  padding: 12px;
}

.navigation-link {
  padding-right: 12px;
  color: white;
}

.paginator {
  text-align: center;
  margin-bottom: 12px;
}

.x-slide-enter-active,
.x-slide-leave-active,
.y-slide-enter-active {
  transition: all 0.3s ease;
}

.x-slide-leave-to {
  transform: translateX(-10%);
  opacity: 0;
}

.x-slide-enter {
  transform: translateX(10%);
  opacity: 0;
}

.y-slide-enter {
  transform: translateY(10%);
  opacity: 0;
}

.inset_1 {
  margin: 0 auto;
  padding-bottom: 2.5em;
  max-width: 80%;
}

.inset_2 {
  margin: 0 auto;
  padding-bottom: 2.5em;
  max-width: 70%;
}

.overview h3 {
  font-size: 2.6em;
  font-weight: bold;
}

.modal-open {
  padding-right: 0 !important;
}

.masonry-card {
  border-radius: 0 !important;
  border: 0 !important;
}

.card-columns .card {
  margin-top: 0.75rem !important;
  margin-bottom: 0 !important;
}

.card-header {
  background-color: initial !important;
  padding: 1rem 1rem 0 1rem !important;
  margin: 0 !important;
  border-bottom: none !important;
}

.card-text {
  height: 40px !important;
  padding: 0 1rem 1rem 1rem !important;
  margin: 0 !important;
}

.card-body,
.card-title {
  padding: 0 !important;
  margin: 0 !important;
}

.card-footer {
  font-size: 2em;
  color: #414141;
  text-align: right;
  border: none !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

.masonry-card:hover {
  cursor: pointer;
}

#search {
  height: 60px;
  padding-left: 19px;
  border: 1px solid #979797 !important;
  border-right: none !important;
}

.search-input {
  margin: 0 auto 12px auto;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

.search-icon-wrapper {
  font-size: 2em;
  padding-right: 30px;
  padding-left: 30px;
  border: 1px solid #979797 !important;
  border-left: none !important;
  line-height: 58px;
}

.button {
  height: 58px;
  line-height: 46px !important;
  min-width: 255px;
  border: none !important;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
  color: white !important;
  font-weight: bold !important;
  background-color: #194173 !important;
  vertical-align: middle;
}

.field {
  height: 58px;
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

.link {
  font-size: 1.6em;
}

.button:hover,
.link:hover {
  cursor: pointer;
}

code {
  color: darkorange !important;
}

.form-group-error input,
.form-group-error select,
.form-group-error textarea {
  border-color: rgb(255, 0, 0);
}

select:disabled {
  background: none;
  color: #121212 !important;
}

.item-remove-icon-wrapper,
.item-select-icon-wrapper,
.item-link-icon-wrapper,
.item-edit-icon-wrapper {
  text-align: center;
}

.item-remove-icon,
.item-select-icon,
.item-link-icon,
.item-edit-icon {
  color: #00bc70;
  font-size: 2em;
  cursor: pointer;
}
.item-link-icon {
  color: #757575;
}
.item-remove-icon {
  color: #a10505;
}

.scroll-to-top {
  position: fixed;
  bottom: 2em;
  right: 0;
  z-index: 2000;
}
.scroll-to-top .background {
  background-color: #00bd70 !important;
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer !important;
}
</style>
